import { listUnifiedJobs } from "../services/URO";
import secureAxios from "./axios/secureAxios";

/**
 * Get list of jobs for current user (uses existing unified jobs endpoint)
 * @param {Object} options
 * @param {number} options.page - Page number (default: 1)
 * @param {number} options.limit - Items per page (default: 20)
 * @param {string} options.job_type - Filter by type ('image' or 'workflow')
 * @returns {Promise<{success: boolean, data: {items: Array, pagination: Object}}>}
 */
async function getJobs({ page = 1, limit = 20, job_type = 'workflow' } = {}) {
  return listUnifiedJobs({ page, limit, job_type });
}

/**
 * Upload an image file
 * @param {FormData} formData - Form data with file
 * @returns {Promise<{success: boolean, data: {url: string}}>}
 */
async function uploadImage(formData) {
  const { data } = await secureAxios.post('/image-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}

/**
 * Toggle like on a job. Returns the new liked state.
 * @param {string} jobId
 * @param {'image'|'workflow'} jobType
 * @returns {Promise<{ liked: boolean }>}
 */
async function toggleLike(jobId, jobType) {
  const { data } = await secureAxios.post(`/jobs/${jobId}/like`, { job_type: jobType });
  return data;
}

/**
 * Get all jobs the user has liked, ordered by liked_at desc.
 * @param {Object} options
 * @param {number} options.page
 * @param {number} options.limit
 * @returns {Promise<Object>} Paginated liked jobs (same shape as getJobs)
 */
async function getLikedJobs({ page = 1, limit = 20 } = {}) {
  const { data } = await secureAxios.get(`/jobs/liked?page=${page}&limit=${limit}`);
  return data;
}

export const jobActions = {
  getJobs,
  uploadImage,
  toggleLike,
  getLikedJobs,
};

export default jobActions;
